import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgLongArrowRight = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 12"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.39 6.266 7.015 9.64a.375.375 0 1 1-.53-.531L9.22 6.375H1.875a.375.375 0 1 1 0-.75H9.22L6.485 2.891a.375.375 0 1 1 .53-.531l3.375 3.375a.375.375 0 0 1 0 .53"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLongArrowRight);
export default ForwardRef;
